<template>
  <div class="p-grid after-sales">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <h2>{{ $t('afterSales.title') }}</h2>
    </div>
    <div v-if="!docTreeRaw || docTreeRaw.length==0" class="p-col after-sales-model-details-body">
      <p><span style="font-weight: normal;">{{ $t('afterSales.models_not_present') }}</span></p>
    </div>
    <div v-else class="p-col-12 p-pt-2 p-pb-2">
      <div class="p-d-flex p-ai-center as-topbar">

        <img src="assets/irinox/icons/home.svg" alt="Home" style="height: 30px;" @click="home()">

        <div class="p-d-flex p-ai-center">

        <!-- Livello 1 -->
          <Dropdown v-if="path[0] && levelOptions(0).length"
            :options="levelOptions(0)"
            optionLabel="label"
            optionValue="value"
            :modelValue="path[0] || null"
            placeholder="Seleziona livello 1"
            @change="onSelectLevel(0, $event.value)"
          />

        <!-- Livello 2 -->
          <Dropdown v-if="path[1] && levelOptions(1).length"
            :options="levelOptions(1)"
            optionLabel="label"
            optionValue="value"
            :modelValue="path[1] || null"
            placeholder="Seleziona livello 2"
            @change="onSelectLevel(1, $event.value)"
          />

        <!-- Livello 3 -->
          <Dropdown v-if="path[2] && levelOptions(2).length"
            :options="levelOptions(2)"
            optionLabel="label"
            optionValue="value"
            :modelValue="path[2] || null"
            placeholder="Seleziona livello 3"
            @change="onSelectLevel(2, $event.value)"
          />

        <!-- Livello 4 -->
          <Dropdown v-if="path[3] && levelOptions(3).length"
            :options="levelOptions(3)"
            optionLabel="label"
            optionValue="value"
            :modelValue="path[3] || null"
            placeholder="Seleziona livello 4"
            @change="onSelectLevel(3, $event.value)"
          />

        <!-- Livello 5 -->
          <Dropdown v-if="path[4] && levelOptions(4).length"
            :options="levelOptions(4)"
            optionLabel="label"
            optionValue="value"
            :modelValue="path[4] || null"
            placeholder="Seleziona livello 5"
            @change="onSelectLevel(4, $event.value)"
          />

        </div>

      </div>
    </div>
    <div class="p-col-12 ">
      <div class="p-grid">
        <div class="p-col-fixed" style="width: 270px">
          <div class="after-sales-menu">
            <div v-for="menuItem in menu" :key="menuItem.label" :class="['after-sales-menu-item',{ 'selected': menuItem.selected },{'clickable': menuItem.route}]" @click="menuClick(menuItem)">
              <span>{{ menuItem.label }}</span>
              <img v-if="menuItem.selected" src="/assets/irinox/icons/as_menu_selected.svg" :alt="menuItem.label" >
              <img v-else src="/assets/irinox/icons/as_menu.svg" :alt="menuItem.label" >
            </div>
          </div>
        </div>
        <div class="p-col">
          <!-- {{docTree}}

          <br><br>

          {{ findModel() }} -->


          

          <!-- Info sul nodo selezionato -->
          <!-- <div v-if="selectedNode">
            <p><strong>Nodo selezionato:</strong> {{ selectedNode.key }}</p>
            <p v-if="selectedNode.docTreeId"><strong>docTreeId:</strong> {{ selectedNode.docTreeId }}</p>
          </div> -->

          <div v-if="!domain">
            <div v-for="item in docTree" :key="item.domain" class="as-tree-block">
              <p>{{ $t('afterSales.domain_' + item.domain.replace(" ", '_')) }}</p>
              <div class="as-tree-list">
                <div v-for="child in item.docTree" :key="item.domain + '|||' +child.key" @click="onSelectLevelFirstLevel(item.domain, child.key)">
                  <img :src="$config.afterSalesAssets('models') + child.key + '.png'" :alt="'MODEL'" :onerror="'if (!this.src.includes(\'.svg\')) this.src=\''+$config.afterSalesAssets('models') + child.key + '.svg\''" /> 
                  <span>{{ child.label }}</span>
                </div>
              </div>
            </div>

          </div>
          <div v-else class="as-tree-block">
            <p><img src="/assets/irinox/icons/arrow_back.svg" alt="Back" @click="backNode()"/> {{ selectedNode?.label }}</p>
            <div class="as-tree-list">
              <div v-for="child in selectedNode?.children" :key="path.join('|||') + '|||' +child.key" @click="onSelectLevel(path.length, child.key)">
                <img :src="$config.afterSalesAssets('models') + child.key + '.png'" :alt="'MODEL'" :onerror="'if (!this.src.includes(\'.svg\')) this.src=\''+$config.afterSalesAssets('models') + child.key + '.svg\''" />
                <span>{{ child.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
</template>

<script>
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';
export default {
  components: { 
    IrinoxDialogDark 
  },
  data() {
    return {
      docTree: [],
      modelsFlat: {},
      menu: [],
      dialog: {
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      domain: 'afterSales/domain',
      path: 'afterSales/path',
      docTreeRawDate: 'afterSales/docTreeRawDate',
      docTreeRaw: 'afterSales/docTreeRaw',
      role: 'userdata/role',
    }),

    domainOptions() {
      // lista domini unici presenti in docTree
      const set = new Set(this.docTree.map(d => d.domain));
      return [...set].map(d => ({ label: d, value: d }));
    },

    selectedNode() {
      return this.findNode(this.domain, this.path);
    }
  },
  watch: {
      '$i18n.locale': 'loadDocTree'
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() {
    this.loadDocTree();
  },
  methods: {
    loadDocTree() {

      this.menu = [
          { label: this.$t('afterSales.menu_models'), route: '/after-sales', selected: true },
          { label: this.$t('afterSales.menu_favorites'), route: '/after-sales/favorites' },
          { label: this.$t('afterSales.menu_searchDocument'), route: '/after-sales/search-document' },
          { label: this.$t('afterSales.menu_searchProduct'), route: '/after-sales/search-product' },
      ]

      if(this.role !== 'USER') {
        this.menu.push( { label: this.$t('afterSales.menu_searchSerial'), route: '/after-sales/search-serial' });
      }

      if(this.role === 'INTERNAL_DOC' || this.role === 'SUPERFACTORY') {
        this.menu.push( { label: this.$t('afterSales.menu_uploadDocuments'), route: '/after-sales/upload-document' } );
        if(this.$config.sparePartsEnabled()) {
          this.menu.push( { label: this.$t('afterSales.menu_uploadExploded'), route: '/after-sales/exploded' } );
          this.menu.push( { label: this.$t('afterSales.menu_catalogue'), route: '/after-sales/catalogue' } );
        }
      }

      // if(this.docTreeRaw.length>0 && this.docTreeRawDate && this.$moment().diff(this.$moment(this.docTreeRawDate), 'hours') < 1) {
      //   console.log("Load docTree from store");
      //     this.convertDocTreeRawInDocTree();
      // } else {
      //   console.log("Load docTree from API");
        this.afterSalesService.getDocTree(this.personaltoken, this.$functions.language(this.$i18n.locale))
          .then((data) => {
            if(data.code=="200") {
              this.$store.commit('afterSales/docTreeRaw', data.body);
              this.convertDocTreeRawInDocTree();
            } else {
              console.error(JSON.stringify(data));
              this.$store.commit('afterSales/docTreeRaw', []);
              this.convertDocTreeRawInDocTree();
              this.$store.commit('afterSales/domain', null);
              this.$store.commit('afterSales/path', []);
              this.dialog.error = true;
            }
            })
          .catch(error => {
            console.error("ERROR "+error);
            this.$store.commit('afterSales/docTreeRaw', []);
            this.convertDocTreeRawInDocTree();
            this.$store.commit('afterSales/domain', null);
            this.$store.commit('afterSales/path', []);
            this.dialog.error = true;
          });
      // }

    },
    home() {
      this.$store.commit('afterSales/domain', null);
      this.$store.commit('afterSales/path', []);
    },
    menuClick(menuItem) {
      this.menu.forEach(item => item.selected = false);
      menuItem.selected = true;
      if(menuItem.route) {
        this.$router.push(menuItem.route);
      }
    },
    convertDocTreeRawInDocTree() {
      this.docTree = [];

      this.docTreeRaw.forEach(item => {
        // Trova (o crea) il dominio
        let domainNode = this.docTree.find(d => d.domain === item.domain);
        if (!domainNode) {
          domainNode = { domain: item.domain, docTree: [] };
          this.docTree.push(domainNode);
        }

        let currentLevel = domainNode.docTree;

        // Itera sui livelli (level1..level5)
        for (let i = 1; i <= 5; i++) {
          const key = item[`level${i}`];
          if (!key) break;

          const label = item[`level${i}Translation`] || key; // fallback a key se manca la traduzione

          let node = currentLevel.find(n => n.key === key);
          if (!node) {
            node = { key, label, children: [] };
            currentLevel.push(node);
          } else {
            // Se il nodo esiste ma non ha label e ora c'è una traduzione, valorizzala
            if (!node.label && label) node.label = label;
          }

          // Se è l'ultimo livello disponibile in questa riga, assegna docTreeId
          if (i === 5 || !item[`level${i+1}`]) {
            node.docTreeId ??= item.docTreeId; // non sovrascrivere se già presente
          }

          currentLevel = node.children;
        }

        //order by domain desc
        this.docTree = this.docTree.sort((a, b) => b.domain.localeCompare(a.domain));

      });
    },
    // === Utility di navigazione ===
    getDomainNode(domain) {
      return this.docTree.find(d => d.domain === domain) || null;
    },

    findNode(domain, path) {
      const domainNode = this.getDomainNode(domain);
      if (!domainNode) return null;

      let currentLevel = domainNode.docTree;
      let node = null;

      for (const key of path) {
        node = currentLevel.find(n => n.key === key);
        if (!node) return null;
        currentLevel = node.children;
      }
      return node;
    },

    // Ritorna le opzioni per il livello `levelIndex` (0-based)
    levelOptions(levelIndex) {
      const prefix = this.path.slice(0, levelIndex);
      const parentNode = this.findNode(this.domain, prefix);

      let children = [];
      if (levelIndex === 0) {
        const domainNode = this.getDomainNode(this.domain);
        children = domainNode ? domainNode.docTree : [];
      } else {
        children = parentNode ? parentNode.children : [];
      }

      // Dedupe per key, ma mostra la label (traduzione)
      const seen = new Set();
      const options = [];
      for (const c of children) {
        if (!seen.has(c.key)) {
          seen.add(c.key);
          options.push({ label: c.label || c.key, value: c.key });
        }
      }
      return options;
    },

    onSelectLevelFirstLevel(domain, value) {
      this.$store.commit('afterSales/domain', domain );
      this.$store.commit('afterSales/path', [value] );
    },

    onSelectLevel(levelIndex, value) {
      // Imposta il valore a quel livello e tronca i successivi
      const newPath = this.path.slice(0, levelIndex);
      newPath[levelIndex] = value;
      let childNode = this.findNode(this.domain, newPath);
      if(childNode?.docTreeId != null) {
        // Se è una foglia, tronca ulteriormente
        this.$router.push({ path: `/after-sales/tree/${childNode.docTreeId}` });
      } else {
        this.$store.commit('afterSales/path', newPath);
      }
    },

    backNode() {
      this.$store.commit('afterSales/pathPop');
      if(this.path.length===0) {
        this.$store.commit('afterSales/domain', null);
      }
    }
  }
}
</script>

<style scoped>
</style>